export default "__VITE_ASSET__D3sVKc_t__"